import { Check, MapPin } from 'lucide-react';
import type { CSSProperties } from 'react';
import { AvatarStack } from './AvatarStack';
import { PlaceArtwork } from './PlaceArtwork';
import type { FamilyLocation, FamilyProfile } from '../types';

interface LocationCardProps {
  location: FamilyLocation;
  people: FamilyProfile[];
  avatarUrls: Record<string, string>;
  isCurrent: boolean;
  isUpdating: boolean;
  onChoose: (locationId: string) => void;
}

export function LocationCard({
  location,
  people,
  avatarUrls,
  isCurrent,
  isUpdating,
  onChoose,
}: LocationCardProps) {
  const peopleRows = Math.ceil(people.length / 3);
  const peopleExtraHeight = Math.max(0, peopleRows - 2) * 50;

  return (
    <article className={`place-card${isCurrent ? ' place-card--current' : ''}`}>
      <button
        className="place-card__action"
        type="button"
        onClick={() => onChoose(location.id)}
        disabled={isUpdating || isCurrent}
        aria-label={isCurrent ? `Sei in ${location.name}` : `Spostami in ${location.name}`}
      >
        <span
          className="place-card__visual"
          style={{ '--people-extra-height': `${peopleExtraHeight}px` } as CSSProperties}
        >
          <PlaceArtwork kind={location.kind} emoji={location.emoji} />
          <AvatarStack profiles={people} avatarUrls={avatarUrls} />
        </span>
        <span className="place-card__title-row">
          <span className="place-card__title"><span aria-hidden="true">{location.emoji}</span> {location.name}</span>
          {isCurrent ? (
            <span className="place-card__current"><Check size={16} aria-hidden="true" /> Sei qui</span>
          ) : (
            <span className="place-card__move"><MapPin size={16} aria-hidden="true" /> Spostami qui</span>
          )}
        </span>
      </button>
    </article>
  );
}
